import type { RawTilesetEntry } from "../tilesetConfigEntry";

export const specialEntries: RawTilesetEntry[] = [
	{
		key: "placeholder",
		sprite: "Placeholder.png",
	},
	{
		key: "Equation",
		animations: [
			{
				height: 2,
				width: 2,
				loop: true,
				tags: { found: true },
				frames: [{ filename: "BlackBoard_C0.png", interval: 1 }],
			},
			{
				height: 2,
				width: 2,
				loop: true,
				tags: { not_found: true },
				frames: [
					{ filename: "BlackBoard_C0.png", interval: 2000 },
					{ filename: "BlackBoard_C1.png", interval: 100 },
					{ filename: "BlackBoard_C2.png", interval: 100 },
					{ filename: "BlackBoard_C1.png", interval: 100 },
				],
			},
		],
	},
	{
		key: "MultiTileThingPartX",
		sprite: "Smallbox_0.png",
	},
	{
		key: "ArtilleryAimIndicator",
		animations: [
			{
				loop: true,
				tags: { stage1: true },
				frames: [
					{ filename: "AimCrossRed.png", interval: 200 },
					{ filename: "Blank.png", interval: 70 },
				],
			},
			{
				loop: true,
				tags: { stage2: true },
				frames: [
					{ filename: "AimCrossRed.png", interval: 50 },
					{ filename: "Blank.png", interval: 17 },
				],
			},
		],
	},
	{
		key: "ArtilleryBotTemp",
		sprite: "WhiteRobot.png",
	},
	{
		key: "DebugIndicator",
		animations: [
			{
				loop: true,
				frames: [
					{ filename: "DebugIndicator_0.png", interval: 100 },
					{ filename: "DebugIndicator_1.png", interval: 100 },
					{ filename: "DebugIndicator_2.png", interval: 100 },
					{ filename: "DebugIndicator_3.png", interval: 100 },
				],
			},
		],
	},
	{
		key: "DebugIndicatorB",
		animations: [
			{
				loop: true,
				frames: [
					{ filename: "DebugIndicatorB_0.png", interval: 100 },
					{ filename: "DebugIndicatorB_1.png", interval: 100 },
					{ filename: "DebugIndicatorB_2.png", interval: 100 },
					{ filename: "DebugIndicatorB_1.png", interval: 100 },
				],
			},
		],
	},
	{
		key: "EffectTester",
		sprite: "DebugIndicator_0.png",
	},
	{
		key: "SolidifiedHorned",
		sprite: "SolidifiedHorned.png",
	},
	{
		key: "SolidifiedSquid",
		sprite: "SolidifiedSquid.png",
	},
	{
		key: "SolidifiedBiter",
		sprite: "SolidifiedBiter.png",
	},
	{
		key: "SolidifiedSlugant",
		animations: [
			{
				loop: true,
				frames: [
					{ filename: "SolidifiedSlugant.png", interval: 250, offsetY: 0 },
					{ filename: "SolidifiedSlugant.png", interval: 250, offsetY: -0.1 },
				],
			},
		],
	},
];
